module.exports = __webpack_public_path__ + "img/image1.7c6b1880.png";